module.exports = __webpack_public_path__ + "img/multi-media-book-icon.9e6cc534.png";